import { render, staticRenderFns } from "./TituloProdutos.vue?vue&type=template&id=e0bd8226&"
import script from "./TituloProdutos.vue?vue&type=script&lang=js&"
export * from "./TituloProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports